export function useFiltersState(args: FiltersStateArgs) {
  const { filters, texts, valueMapping } = args;

  const hasSomeFilters = Object.values(filters).some(val => !!val);

  const activeFiltersTexts = Object.entries(filters).reduce((acc, [key, value]) => {
    if (!value) return acc;
    acc.push(`${texts[key]}: "${valueMapping?.[key]?.(value) ?? value}"`);
    return acc;
  }, []);

  return { hasSomeFilters, activeFiltersTexts };
}

interface FiltersStateArgs {
  filters: object;
  texts: Record<string, string>;
  valueMapping?: Record<string, (value: string) => string>;
}